import React, { useState, useEffect } from 'react';
import Chart from 'react-apexcharts';

export const DonutChart = (props) => {
  const {
    list,
    language: { name },
    intl,
  } = props;

  const [chartWidth, setChartWidth] = useState('100%');
  const [chartHeight, setChartHeight] = useState('250px');
  const [fontSize, setFontSize] = useState('14px');

  const handleResize = () => {
    if (window.screen.width > 1200 || window.screen.width < 992) {
      setChartWidth('100%');
      setChartHeight('250px');
      setFontSize('12px');
    } else {
      setChartWidth('90%');
      setChartHeight('200px');
      setFontSize('8px');
    }
  };

  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  let series = list.map((item) => {
    return item?.count;
  });

  let cityLabels = list.map((item) => {
    return item?.name[name];
  });

  const options = {
    labels: cityLabels,
    dataLabels: {
      enabled: true,
      offset: 10,
      style: {
        fontSize: fontSize,
      },
    },
    legend: {
      show: false,
    },
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            total: {
              show: true,
              label: intl.formatMessage({
                id: 'booking.sum',
              }),
            },
          },
        },
      },
    },
  };

  return (
    <div>
      <Chart
        options={options}
        series={series}
        type="donut"
        width={chartWidth}
        height={chartHeight}
      />
    </div>
  );
};
